import { Injectable } from '@angular/core';
import { Vcu } from '../model/form/vcu';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { VcuRequest } from '../model/request/vcu-request';
import { VcuResponse } from '../model/response/vcu-response';
import { Item } from '../model/Item';
import { Status } from '../model/enum/status';
import { FindUserVcusGetResp, ProjectsFindUserVcusGetResp } from '../model/response/find-user-vcus-get-resp';
import { ProjectService } from './project.service';
import { Image } from 'src/app/model/Image';
import {
  VcuDevice, VcuListResponse, PairGenerateResponse,
  VcuUpdateRequest, VcuUnpairResponse
} from '../model/vcu-pair.model';
import { VcuFileType, VcuFilesResponse, VcuFileItem, FileFilters } from '../model/response/vcu-files-response';
import { HttpParams } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class VcuService {

  httpOptions: {};
  vcuRequest: VcuRequest;
  userID: string = sessionStorage.getItem('userID') ?? '';
  projectID: string = '';
  vcuID: string = '';
  vcuUrl: string = enviroment.BASE_URL_API + '/user';

  constructor(private http: HttpClient) {
    this.httpOptions = {};
    let idToken = sessionStorage.getItem('idToken') || ""
        this.httpOptions = {
          headers: new HttpHeaders({  
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${idToken}`
          })
        };
    this.vcuRequest = new VcuRequest();
  }


  findVcu():Observable<VcuResponse> {
    return this.http.get<VcuResponse>(enviroment.BASE_URL_API 
      + '/user/' + this.userID 
      + '/project/' + this.projectID 
      + '/vcu/' + this.vcuID , this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<VcuResponse>('findVcu'))
    );
  }

  getVcu():Observable<FindUserVcusGetResp[]> {
    return this.http.get<FindUserVcusGetResp[]>(enviroment.BASE_URL_API 
      + '/user/' + this.userID 
      + '/vcu/' + this.vcuID , this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<FindUserVcusGetResp[]>('getVcu'))
    );
  }

  createVcu(vcu: Vcu) : Observable<VcuResponse> {
    let vcuRequest = VcuService.toVcuRequest(vcu);  
    let url = `${this.vcuUrl}/${this.userID}/vcu`
    return this.http.post<VcuResponse>(url, vcuRequest, this.httpOptions).pipe(tap());
  }

  updateVcu(vcu: Vcu) : Observable<VcuResponse> {
    let vcuRequest = VcuService.toVcuRequest(vcu);  

    return this.http.put<VcuResponse>(this.vcuUrl + '/' + this.userID + '/vcu/' + this.vcuID, vcuRequest, this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<VcuResponse>('updateVcu'))
    );
  }

  updateVcuNoProject(vcu: Vcu) : Observable<VcuResponse> {
    let vcuRequest = VcuService.toVcuRequest(vcu);  

    return this.http.put<VcuResponse>(this.vcuUrl + '/' + this.userID + '/vcu/' + this.vcuID, vcuRequest, this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<VcuResponse>('updateVcuNoProject'))
    );
  }

  deleteVcu() : Observable<VcuResponse> {
    return this.http.delete<VcuResponse>(this.vcuUrl + '/' + this.userID + '/project/' + this.projectID + '/vcu/' + this.vcuID, this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<VcuResponse>('deleteVcu'))
    );
  }

  deleteVcuNoProject() : Observable<VcuResponse> {
    return this.http.delete<VcuResponse>(this.vcuUrl + '/' + this.userID + '/vcu/' + this.vcuID, this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<VcuResponse>('deleteVcu'))
    );
  }

  linkVcuInProject() {
    return this.http.put<{}>(this.vcuUrl + '/' + this.userID + '/project/' + this.projectID + '/vcu/' + this.vcuID, {}, this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<{}>('addVcu'))
    );
  }

  unlinkVcuInProject() {
    return this.http.delete<{}>(this.vcuUrl + '/' + this.userID + '/project/' + this.projectID + '/vcu/' + this.vcuID, this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<{}>('addVcu'))
    );
  }
  vcuImage(idAux: number , vcu: Vcu): Observable<Image> {
    let modelName = vcu.model?.name || '';
    let imgname = modelName.replace(/\s+/g, '').toUpperCase() || 'default';
    let imageVCU = new Image(idAux, `${imgname}`, `${enviroment.BASE_URL_API_IMAGE_VCU}/` + imgname + '.png');
    return of(imageVCU);
  }

  static toVcuRequest(vcu: Vcu) {
    //TODO converter campos e montar a REQUEST do backend
    return new VcuRequest(
      vcu.serialNumber, 
      vcu.surname, 
      vcu.family?.id, 
      vcu.model?.id, 
      vcu.invoice, 
      vcu.purchaseDate?.toISOString(),
      vcu.tags,
      vcu.vcuAttributes?.reasonUnlink);
  }

  static toVcu(vcu: VcuResponse) : Vcu {
    if(vcu) {
      return new Vcu(
        vcu.id,
        null,
        vcu.nickname,
        new Item(vcu.familyID, vcu.familyDescription),
        new Item(vcu.modelID, vcu.modelDescription),
        vcu.serialNumber,
        new Item(vcu.resellerID, vcu.resellerDescription),
        vcu.invoiceNumber,
        (vcu.purchaseDate ? new Date(vcu.purchaseDate) : null),
        (vcu.vcuAttributes ? vcu.vcuAttributes.tags?.split(",") ?? [] : []),
        (vcu.modifiedDate ? new Date(vcu.modifiedDate) : null),
        (vcu.status ? vcu.status as Status : null),
        (vcu.createdDate ? new Date(vcu.createdDate) : null),
        (vcu.lastAccess ? new Date(vcu.lastAccess) : null),
        vcu.vcuAttributes ?? null,
        ProjectService.toProjects(vcu.projects)
      );
    }
    return new Vcu();
  }

  static userVcuToVcu(vcu: FindUserVcusGetResp) : Vcu {
    return new Vcu(
      vcu.id ?? '',
      null,
      vcu.nickname ?? '',
      new Item(vcu.family?.familyID, vcu.family?.description),
      new Item(vcu.model?.id, vcu.model?.name ),
      vcu.serial ?? '',
      new Item(vcu.reseller?.resellerID, vcu.reseller?.description),
      vcu.invoiceNumber ?? '',
      (vcu.purchaseDate ? new Date(vcu.purchaseDate) : null),
      vcu.vcuAttributes?.tags?.split(',') ?? [],
      (vcu.createdDate ? new Date(vcu.createdDate) : null),
      (vcu.status ? vcu.status as Status : null),
      (vcu.createdDate ? new Date(vcu.createdDate) : null),
      (vcu.lastAccess ? new Date(vcu.lastAccess) : null),
      vcu.vcuAttributes ?? null,
      vcu.projects ? ProjectService.userProjectToProjects(vcu.projects) : []
    );
  }

  static userVcuToVcus(vcusResp: FindUserVcusGetResp[]) : Vcu[] {
    let vcus: Vcu[] = [];
    vcusResp.forEach(resp => vcus.push(VcuService.userVcuToVcu(resp)))
    return vcus;
  }

  static userVcuToProjects(vcusResp: FindUserVcusGetResp) : ProjectsFindUserVcusGetResp[] {
    let projects: ProjectsFindUserVcusGetResp[] = [];
      if(vcusResp.projects) {
        for(let proj of vcusResp.projects) {
          projects.push(new ProjectsFindUserVcusGetResp(proj.projectID, proj.projectName))
        }
      }
    return projects;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  setUserID(userID: string){
    this.userID = userID;
  }

  setProjectID(projectID: string){
    this.projectID = projectID;
  }

  getProjectID() : string {
    return this.projectID;
  }

  setVcuID(vcuID: string){
    this.vcuID = vcuID;
  }

  // =============================================
  // Métodos de Pareamento (Pairing)
  // =============================================

  /**
   * Retorna headers atualizados com o token mais recente do sessionStorage.
   * Necessário porque o VcuService é singleton (providedIn: 'root') e
   * o token/userId podem não existir no momento da instanciação.
   */
  private getAuthHeaders(): { headers: HttpHeaders } {
    const idToken = sessionStorage.getItem('idToken') || '';
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${idToken}`
      })
    };
  }

  private getCurrentUserId(): string {
    return sessionStorage.getItem('userID') ?? this.userID ?? '';
  }

  generatePairCode(): Observable<PairGenerateResponse> {
    const url = `${enviroment.BASE_URL_API}/api/vcu/pair/generate`;
    return this.http.post<PairGenerateResponse>(url, {}, this.getAuthHeaders()).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  getPairedVcus(): Observable<VcuListResponse> {
    const userId = this.getCurrentUserId();
    // Param `_t` + headers no-cache evitam que o navegador sirva uma resposta
    // em cache durante o polling de pareamento (senão o modal de sucesso pode
    // exibir dados de uma VCU pareada anteriormente).
    const url = `${enviroment.BASE_URL_API}/api/user/${userId}/vcus?_t=${Date.now()}`;
    const idToken = sessionStorage.getItem('idToken') || '';
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${idToken}`,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      })
    };
    return this.http.get<VcuListResponse>(url, options).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  updateVcuNickname(serialNumber: string, nickname: string): Observable<VcuDevice> {
    const userId = this.getCurrentUserId();
    const url = `${enviroment.BASE_URL_API}/api/user/${userId}/vcu/${serialNumber}`;
    const body: VcuUpdateRequest = { nickname };
    return this.http.patch<VcuDevice>(url, body, this.getAuthHeaders()).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  unpairVcu(serialNumber: string): Observable<VcuUnpairResponse> {
    const userId = this.getCurrentUserId();
    const url = `${enviroment.BASE_URL_API}/api/user/${userId}/vcu/${serialNumber}`;
    return this.http.delete<VcuUnpairResponse>(url, this.getAuthHeaders()).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  /**
   * Lista arquivos do usuário com filtros opcionais (endpoint unificado).
   * GET /user/{userID}/files?projectID=&vcuID=&type=&page=&pageItens=
   * Sem filtros retorna todos os arquivos não excluídos.
   */
  getUserFiles(userId: string, filters?: FileFilters): Observable<VcuFilesResponse> {
    let params = new HttpParams();
    if (filters?.projectID) params = params.set('projectID', filters.projectID);
    if (filters?.vcuID) params = params.set('vcuID', filters.vcuID);
    if (filters?.type) params = params.set('type', filters.type);
    if (filters?.page != null) params = params.set('page', filters.page.toString());
    if (filters?.pageItens != null) params = params.set('pageItens', filters.pageItens.toString());
    const url = `${enviroment.BASE_URL_API}/user/${userId}/files`;
    return this.http.get<VcuFilesResponse>(url, { ...this.getAuthHeaders(), params }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  /**
   * @deprecated Use getUserFiles(userId, { vcuID, type }) em vez deste método.
   * GET user/{userID}/vcu/{vcuID}/files?fileType=Map|Log&page&pageItens
   */
  getVcuFiles(
    userId: string,
    vcuId: string,
    fileType: VcuFileType,
    page?: number,
    pageItens?: number
  ): Observable<VcuFilesResponse> {
    let params = new HttpParams().set('fileType', fileType);
    if (page != null) params = params.set('page', page.toString());
    if (pageItens != null) params = params.set('pageItens', pageItens.toString());
    const url = `${enviroment.BASE_URL_API}/user/${userId}/vcu/${vcuId}/files`;
    return this.http.get<VcuFilesResponse>(url, { ...this.getAuthHeaders(), params }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  /**
   * Download de arquivo da VCU.
   * GET user/{userID}/vcu/{vcuID}/{folder}/{file}
   * Resposta: string (URL pré-assinada) ou o recurso conforme integração do backend.
   * @param folder Tipo do arquivo: 'log' ou 'map'
   */
  downloadVcuFile(
    userId: string,
    vcuId: string,
    folder: string,
    fileId: string,
    start: number = 0,
    end: number = 10483712
  ): Observable<HttpResponse<Blob>> {
    const url = `${enviroment.BASE_URL_API}/files/user/${userId}/vcu/${vcuId}/${folder}/${fileId}`;
    const idToken = sessionStorage.getItem('idToken') || '';
    return this.http.get<Blob>(url, {
      headers: new HttpHeaders({
        Accept: 'application/octet-stream',
        Range: `bytes=${start}-${end}`,
        Authorization: `Bearer ${idToken}`
      }),
      observe: 'response',
      responseType: 'blob' as 'json'
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  /**
   * Download de arquivo do usuário (sem VCU).
   * GET /files/user/{userID}/{folder}/{fileId}
   * @param folder Tipo do arquivo: 'log' ou 'map'
   */
  downloadUserFile(
    userId: string,
    folder: string,
    fileId: string,
    start: number = 0,
    end: number = 10483712
  ): Observable<HttpResponse<Blob>> {
    const url = `${enviroment.BASE_URL_FILES}/files/user/${userId}/${folder}/${fileId}`;
    const idToken = sessionStorage.getItem('idToken') || '';
    return this.http.get<Blob>(url, {
      headers: new HttpHeaders({
        Accept: 'application/octet-stream',
        Range: `bytes=${start}-${end}`,
        Authorization: `Bearer ${idToken}`
      }),
      observe: 'response',
      responseType: 'blob' as 'json'
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  /**
   * Exclui (soft delete) um arquivo da VCU.
   * DELETE user/{userID}/vcu/{vcuID}/{folder}/{file}
   * @param folder Tipo do arquivo: 'log' ou 'map'
   */
  deleteVcuFile(userId: string, vcuId: string, folder: string, fileId: string): Observable<void> {
    const url = `${enviroment.BASE_URL_API}/user/${userId}/vcu/${vcuId}/${folder}/${fileId}`;
    return this.http.delete<void>(url, this.getAuthHeaders()).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  /**
   * Hard delete de map/log do usuário (sem contexto de projeto/VCU).
   * DELETE /user/{userID}/mapOrLogID/{fileId}?type=MAP|LOG
   * Ação irreversível — confirme com o usuário antes de chamar.
   * Backend responde 200 (sucesso), 400 (type inconsistente), 403 (não é dono), 404 (não encontrado).
   */
  deleteUserFile(userId: string, fileId: string, type: 'MAP' | 'LOG'): Observable<void> {
    const params = new HttpParams().set('type', type);
    const url = `${enviroment.BASE_URL_API}/user/${userId}/mapOrLogID/${fileId}`;
    return this.http.delete<void>(url, { ...this.getAuthHeaders(), params }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  /**
   * Atualiza dados de um arquivo já sincronizado.
   * PUT /user/{userID}/files/{fileID}
   * Campos ausentes ou null não são modificados.
   * Para desvincular de projeto/VCU, enviar Guid.Empty (00000000-0000-0000-0000-000000000000).
   */
  updateFile(
    userId: string,
    fileId: string,
    body: { file?: string; pathFile?: string; projectID?: string; vcuID?: string }
  ): Observable<VcuFileItem> {
    const url = `${enviroment.BASE_URL_API}/user/${userId}/files/${fileId}`;
    return this.http.put<VcuFileItem>(url, body, this.getAuthHeaders()).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }
}
